import React from 'react';
import ConfirmationPopup from '../../../ConfirmationPopup/ConfirmationPopup';

interface CancelConfirmDialogProps {
    onConfirm: () => void;
    onDismiss: () => void;
    /** Defaults to the Magic Sign "Cancel signing link?" copy — pass to reuse this dialog elsewhere. */
    title?: string;
    subTitle?: string;
    confirmCta?: string;
    cancelCta?: string;
}

const CancelConfirmDialog: React.FC<CancelConfirmDialogProps> = ({
    onConfirm,
    onDismiss,
    title = 'Cancel signing link?',
    subTitle = 'This will invalidate all existing signing links for this document. Signatories will no longer be able to sign. This action cannot be undone.',
    confirmCta = 'Cancel Signing',
    cancelCta = 'Keep',
}) => (
    <ConfirmationPopup
        open
        title={title}
        subTitle={subTitle}
        confirmCta={confirmCta}
        cancelCta={cancelCta}
        onConfirm={() => onConfirm()}
        onCancel={onDismiss}
    />
);

export default CancelConfirmDialog;
